<template>
  <section class="page-container">
    <h1>{{ title }}</h1>
    <!--    <span>{{ pageConfig.total }} tickets</span>-->
    <div class="btn-top-container">
      <v-button
        type="plain"
        @click="newTicketDialog = true">New Support Ticket</v-button>
    </div>

    <div
      class="filter-top">
      <div class="mg-b-30">
        <v-radio-group
          v-model="merchant_platform"
          button
          :list="serverTypeOption"
          @change="searchData"></v-radio-group>
      </div>
      <div class="form-item">
        <!--        <span>Search</span>-->
        <v-input
          v-model="search"
          :prefixIcon="'el-icon-search'"
          placeholder="Ticket, Customer Name, Customer Contact, CS Name"
          @keyEnter="searchData" />
      </div>
    </div>
    <div
      v-if="ticketsType !== 'snoozed'"
      class="filter-bar pointer"
      :class="{
        'blue-bg': diff,
        'border-bottom-radius': !showFilterCard}"
      @click="handleShowFilter">
      <div class="main-left">
        <div class="left">
          <font-awesome-icon
            icon="filter"
            class="icon icon-filter"></font-awesome-icon>
          <span class="text">Filter</span>
        </div>
        <div class="filter-status">
          <span
            v-for="(item, i) in statusList"
            :key="i"
            class="status-item">
            <span class="status-title">
              {{item.title}}:
            </span>
            <span class="content">
              {{item.content}}
            </span>
          </span>
        </div>
      </div>
      <div class="right">
        <div
          v-if="diff"
          class="translucence"></div>
        <div class='right-content'>
          <font-awesome-icon
            v-show="diff"
            icon="rotate-left"
            class="icon icon-rotate pointer"
            @click.stop="resetFilter"></font-awesome-icon>
          <font-awesome-icon
            v-if="showFilterCard"
            icon="square-minus"
            class="icon pointer"
          ></font-awesome-icon>
          <font-awesome-icon
            v-else
            icon="square-plus"
            class="icon pointer"
          >
          </font-awesome-icon>
        </div>
      </div>
    </div>
    <div
      v-if="ticketsType !== 'snoozed' && showFilterCard"
      class="filter-container border-bottom-radius">
      <div class="filter-left">
        <div class="form-item">
          <span>Created</span>
          <div class="flex">
            <v-date-picker
              v-model="refer_date"
              :clearable="true"
              type="daterange"
              @change="searchData" />
          </div>
        </div>
        <div
          v-if="ticketsType === 'all'"
          class="form-item">
          <span>Assignee</span>
          <v-select
            v-model="assignee_id"
            icon="user-nurse"
            :clearable="true"
            :list="globalOptions.assignee"
            @change="searchData" />
        </div>
        <div
          v-if="ticketsType === 'all'"
          class="filter-box snooze-filter">
          <div class="form-item ">
            <span>Snooze</span>
            <v-checkbox-group
              v-model="is_snooze"
              :borderBlock="true"
              :list="snoozeTypeOptions"
              @change="searchData" />
          </div>
        </div>
        <div
          v-if="ticketsType === 'all'"
          class="form-item status-button">
          <span>Status</span>
          <div class="flex">
            <v-checkbox-group
              v-model="status"
              :borderBlock="true"
              block
              :list="statusTypeOptions"
              @change="searchData" />
          </div>
        </div>
        <div
          v-else
          class="filter-box status-button">
          <div class="filter-box-text">
            <span>Status</span>
          </div>
          <div class="flex">
            <v-checkbox-group
              v-model="status"
              :borderBlock="true"
              :list="statusAllTypeOptions"
              @change="searchData" />
          </div>
        </div>
        <div class="form-item">
          <span>
            Channel
            <span
              class="all"
              @click="handlerSelectAll('source')">All</span>
            <span
              class="all"
              @click="handlerNoneAll('source')">None</span>
          </span>
          <span>
            <v-checkbox-group
              v-model="source"
              :list="specialOptions.source"
              :isColumn="false"
              @change="filterData"
            />
          </span>
        </div>
      </div>

      <div class="filter-middler type-button">
        <div class="filter-box-text">
          <span>Type & Stage</span>
        </div>
        <div class="flex">
          <div class="flex">
            <div class="border-none mg-b-16">
              <el-radio
                v-model="type"
                :label="0"
                @click="handlerRaido"
                @change="handlerRaido">All</el-radio>
              <div class="mg-t-15">
                <el-radio
                  v-model="type"
                  :label="1"
                  @change="handlerRaido">General</el-radio>
              </div>
            </div>
          </div>
          <div>
            <div class="flex mg-b-16">
              <div>
                <el-radio
                  v-model="type"
                  :label="2"
                  @change="handlerRaido">Refer Case</el-radio>
                <div
                  class="flex-checkout">
                  <v-checkbox-group
                    v-model="stts_2"
                    :type="2"
                    :list="globalOptions.ticket_refer_status"
                    @change="filterData" >
                    <template #default="{ item }">
                      <span class="flex">
                        <span
                          class="circle"
                          :class="{
                            'orange-light': [1, 3,5].includes(item.id),
                            'yellow-dark':[0].includes(item.id),
                            'blue': [2,4].includes(item.id),
                            'green': [6].includes(item.id),
                          }"></span>
                        <span>{{ item['name'] }}</span>
                      </span>
                    </template>
                  </v-checkbox-group>
                </div>
              </div>
              <div>
                <el-radio
                  v-model="type"
                  :label="3"
                  @change="handlerRaido">Endorsement</el-radio>
                <div
                  class="flex-checkout">
                  <v-checkbox-group
                    v-model="stts_3"
                    :type="3"
                    :list="globalOptions.ticket_endorse_status"
                    @change="filterData" >
                    <template #default="{ item }">
                      <span class="flex">
                        <span
                          class="circle"
                          :class="{
                            'orange-light': [101,301].includes(item.id),
                            'yellow-dark': [0].includes(item.id),
                            'blue': [201, 501].includes(item.id),
                            'green': [601].includes(item.id),
                            'red': [401].includes(item.id),
                          }"></span>
                        <span>{{ item['name'] }}</span>
                      </span>
                    </template>
                  </v-checkbox-group>
                </div>
              </div>
              <div>
                <el-radio
                  v-model="type"
                  :label="9"
                  @change="handlerRaido">Renew</el-radio>
                <div
                  class="flex-checkout">
                  <v-checkbox-group
                    v-model="stts_9"
                    :type="9"
                    :list="renewOptions"
                    @change="filterData" >
                    <template #default="{ item }">
                      <span class="flex">
                        <span
                          class="circle"
                          :class="{
                            'blue': item.id === 2,
                            'yellow-dark': item.id === 3,
                            'red': [4,6].includes(item.id ),
                            'orange-light': item.id === 5,
                            'gray': item.id === 1,
                            'green': item.id === 7
                          }"></span>
                        <span>{{ item['name'] }}</span>
                      </span>
                    </template>
                  </v-checkbox-group>
                </div>
              </div>

            </div>
            <div class="flex">
              <div>
                <el-radio
                  v-model="type"
                  :label="4"
                  @change="handlerRaido">HD Transfer</el-radio>
                <div
                  class="flex-checkout"
                >
                  <v-checkbox-group
                    v-model="stts_4"
                    :type="4"
                    :list="globalOptions.ticket_transfer_status"
                    @change="filterData" >
                    <template #default="{ item }">
                      <span class="flex">
                        <span
                          class="circle"
                          :class="{
                            'yellow-dark':  [1].includes(item.id),
                            'blue': [4].includes(item.id),
                            'green': [2].includes(item.id),
                            'red': [3].includes(item.id),
                          }"></span>
                        <span>{{ item['name'] }}</span>
                      </span>
                    </template>
                  </v-checkbox-group>
                </div>
              </div>
              <div>
                <el-radio
                  v-model="type"
                  :label="5"
                  @change="handlerRaido">Special/SME</el-radio>
                <div
                  class="flex-checkout"
                >
                  <v-checkbox-group
                    v-model="stts_5"
                    :type="5"
                    :list="globalOptions.ticket_manual_status"
                    @change="filterData">
                    <template #default="{ item }">
                      <span class="flex">
                        <span
                          class="circle"
                          :class="{
                            'yellow-dark':  [0].includes(item.id),
                            'green': [1].includes(item.id),
                          }"></span>
                        <span>{{ item['name'] }}</span>
                      </span>
                    </template>
                  </v-checkbox-group></div>
              </div>
              <div>
                <el-radio
                  v-model="type"
                  :label="6"
                  @change="handlerRaido">Claims</el-radio>
                <div
                  class="flex-checkout">
                  <v-checkbox-group
                    v-model="stts_6"
                    :type="6"
                    :list="claimsList"
                    @change="filterData" >
                    <template #default="{ item }">
                      <span class="flex">
                        <span
                          class="circle"
                          :class="{
                            'yellow-dark': [0].includes(item.id),
                            'blue': [1].includes(item.id),
                            'purple': [2].includes(item.id),
                            'green': [3].includes(item.id),
                            'red': [4].includes(item.id),
                          }"></span>
                        <span>{{ item['name'] }}</span>
                      </span>
                    </template>
                  </v-checkbox-group></div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="filter-right">
        <div class="form-item">
          <span>
            Product Type
            <span
              class="all"
              @click="handlerSelectAll('class_id')">All</span>
            <span
              class="all"
              @click="handlerNoneAll('class_id')">None</span>
          </span>
          <div class="flex-sb">
            <div class="half">
              <span>Auto-Quote</span>
              <v-checkbox
                v-model="motor_select"
                class="mg-t-8 mg-b-10"
                :is-indeterminate="isAllMotorSelect"
                :disabled="productDisable"
                @change="handleSelectQuote"><span class="fs-14 color-dark fw-600">Motors</span></v-checkbox>
              <v-checkbox-group
                v-model="class_id"
                :list="motorClassOptions"
                :disabled="productDisable"
                :isColumn="false"
                @change="filterData(type)"></v-checkbox-group>
              <v-checkbox
                v-model="none_motor_select"
                class="mg-t-8 mg-b-10"
                :is-indeterminate="isNoneMotorSelect"
                :disabled="productDisable"
                @change="handleSelectNoneQuote"><span class="fs-14 color-dark fw-600">Non-Motors</span></v-checkbox>
              <v-checkbox-group
                v-model="class_id"
                :list="noneMotorClassOptions"
                :disabled="productDisable"
                :isColumn="false"
                @change="filterData(type)"></v-checkbox-group>

            </div>
            <div class="half">
              <span
                class="display-flex flex-sb-center"
              >
                <span>SME</span>
              </span>
              <section>
                <v-checkbox-group
                  v-model="class_id"
                  :list="sme_class_data"
                  :disabled="productDisable"
                  :isColumn="false"
                  @change="filterData(type)"></v-checkbox-group>
              </section>
            </div>
          </div>
        </div>
        <!--        <div class="filter-box-text">-->
        <!--          <span>Product Type</span>-->
        <!--          <span-->
        <!--            class="all"-->
        <!--            @click="handlerSelectAll('class_id')">All</span>-->
        <!--          <span-->
        <!--            class="all"-->
        <!--            @click="handlerNoneAll('class_id')">None</span>-->
        <!--        </div>-->
        <!--        <div class="flex">-->
        <!--          <v-checkbox-group-->
        <!--            v-model="class_id"-->
        <!--            class="flex-wrap"-->
        <!--            :disabled="productDisable"-->
        <!--            :list="specialOptions.ticket_class_type"-->
        <!--            @change="filterData(type)"></v-checkbox-group>-->
        <!--        </div>-->
      </div>
    </div>
    <div
      v-if="selectionTickets.length>0"
      class="text-right">
      <v-button
        :disabled="disabledBtn"
        @click="handlerClearSelection">Clear Selection</v-button>
      <v-button
        v-show="ticketsType !== 'snoozed'"
        :disabled="disabledBtn"
        @click="handlerSelected('resolved')">Mark As Resolved</v-button>
      <v-button
        v-show="ticketsType === 'snoozed'"
        :disabled="disabledBtn"
        class="button-blue"
        @click="handlerSelected('unsnooze')">Unsnooze Now</v-button>
      <v-select
        v-show="ticketsType === 'unassigned'"
        v-model="assignee"
        icon="user-nurse"
        class="filter-select"
        :disabled="disabledBtn"
        placeholder="Assign CS..."
        :list="globalOptions.assignee"
        @change="selectAssignee" />
    </div>

    <div
      v-if="ticketsType"
      class="transparent">
      <list-table
        :tableData="tableData"
        @rowClick="rowClick"
        @selectionChange="handleSelectionChange"></list-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />

    <v-dialog
      v-model="newTicketDialog"
      width="800px">
      <div class="dialog-container">
        <div class="dialog-header">
          <h2>New Support Ticket</h2>
          <div class="abs-top-right">
            <v-button @click="newTicketDialog = false">Cancel</v-button>
            <v-button type="primary">Create</v-button>
          </div>
        </div>
        <div class="dialog-body">
          <v-button
            class="mg-l-0"
            blue
            @click="openSupportTicketDialog('new-general-ticket')">General</v-button>
          <!-- <span
            class="span-checkbox"
            @click="openSupportTicketDialog('new-endorsement-ticket')">Endorsement</span> -->
          <v-button
            class="mg-t-10 mg-l-0"
            blue
            @click="openSupportTicketDialog('new-credit-ticket')">HD Transfer</v-button>
          <v-button
            class="mg-t-10 mg-l-0"
            disabled
            blue
            @click="openSupportTicketDialog('new-business-ticket')">Business</v-button>
        </div>
      </div>
    </v-dialog>

    <new-general-ticket
      ref="new-general-ticket"
      is-create />
    <new-endorsement-ticket
      ref="new-endorsement-ticket" />
    <new-credit-ticket
      ref="new-credit-ticket" />
    <new-business-ticket
      ref="new-business-ticket" />

  </section>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import NewGeneralTicket from './dialogs/new-general-ticket'
import NewEndorsementTicket from './dialogs/new-endorsement-ticket'
import NewCreditTicket from './dialogs/new-credit-ticket'
import NewBusinessTicket from './dialogs/new-business-ticket'
import ListTable from './components/list-table.vue'
import {
  getAllTicketList,
  getSnoozedTicketList,
  getUnassignedTicketList,
  getUnresolvedTicketList,
  setResolvedTicket,
  setTicketClientUpdated,
  setTicketCs,
  setTicketUnsnooze
} from '@/api/ticket'
import MixinOptions from '@/mixins/options'
import MixinProductTypeFilter from '@/mixins/product-type-filter'


export default {
  name: 'TicketsList',
  components: {
    NewGeneralTicket,
    NewEndorsementTicket,
    NewCreditTicket,
    NewBusinessTicket,
    ListTable
  },
  mixins: [MixinOptions,MixinProductTypeFilter],
  data() {
    return {
      is_ticket:true,
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      search: '',
      merchant_platform: '',
      assignee_id: '',
      refer_date: [],
      type: 0,
      source: [],
      is_snooze: [],
      status: [1,2],
      newTicketDialog: false,
      tableData: [],
      selectionTickets: [],
      assignee: '',
      stts:[],
      stts_2:[],
      stts_3:[],
      stts_4:[],
      stts_5:[],
      stts_6:[],
      stts_9:[],
      selectRow:[],
      isFirst:false,
      productDisable: true,
      statusList: [],
      showFilterCard: true,
      defaultFilter:{
        refer_date: [],
        assignee_id: '',
        source: [],
        is_snooze: [],
        status: [1,2],
        type: 0,
        class_id: [],
        merchant_platform:''
      }
    }
  },
  computed: {
    ...mapState('common', ['globalOptions']),
    ...mapState('filter', ['selectFilterData','openFilterCar']),
    channelList(){
      return this.specialOptions.source || []
    },
    ticketsType() {
      return this.$route.params.type
    },
    title() {
      if(this.ticketsType === 'all') {
        return 'All Tickets'
      }
      else if(this.ticketsType === 'unresolved') {
        return 'My Unresolved Tickets'
      }
      else if(this.ticketsType === 'unassigned') {
        return 'Unassigned Tickets'
      }
      else {
        return 'My Snoozed Tickets'
      }
    },
    disabledBtn() {
      return this.selectionTickets.length < 1
    },
    ticketIdList() {
      return this.selectionTickets.reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
    },
    ticketTypeList(){
      let arr = this.ticketListOptions
      arr.unshift({name:'All',id:''})
      return arr
    },
    diff(){
      let res = false
      Object.keys(this.defaultFilter).forEach(key => {
        if(this[key]){
          let vue_data = JSON.parse(JSON.stringify(this[key]))
          let default_data = JSON.parse(JSON.stringify(this.defaultFilter[key]))
          if(Array.isArray(vue_data) && Array.isArray(default_data)){
            vue_data.sort()
            default_data.sort()
          }
          if(JSON.stringify(vue_data) != JSON.stringify(default_data)){
            res =  true
          }
        }
      })
      return res
    },
    claimsList(){
      // let list = this.globalOptions.ticket_claim_status
      // list.forEach(item => {
      //   if(item.id == 3){
      //     item.name = 'Settled w Cheque'
      //   }
      // })
      // return list
      return this.globalOptions.ticket_claim_status || []
    },
    renewOptions() {
      return this.globalOptions.ticket_renew_status
    },
  },
  watch: {
    ticketsType: {
      immediate: true,
      handler(val, old) {
        this.$nextTick(() => {
          // this.$refs['table'].doLayout()
          this.tableData = []
          this.pageConfig.currentPage = 1
          this.type = 0
          this.refer_date = []
          let {ticket={}} =  this.selectFilterData||{}
          Object.keys(ticket).forEach(item=>{
            this[item] = ticket[item]
            if(item=='stts'){
              this[`stts_${ticket.type}`] =  ticket.stts
            }
          })
          let filterCar =  this.openFilterCar||{}
          let ticket_type = filterCar.ticket||{}
          let {showFilterCard=true} =  ticket_type[`ticket_${val}`]||{}
          this.showFilterCard = showFilterCard
          let {type='',pageConfig} = ticket||{}
          setTimeout(()=>{
            this.type = type||0
          },50)
          if(ticket){
            this.isFirst =true
          }
          this.setFilterData(ticket||{})
          this.handler().handlerGetData()
        })
      }
    },
    type:{
      immediate: true,
      handler(val, old){
        if([2,3,6,9].includes(val)){
          this.productDisable = false
        }else{
          this.productDisable = true
          this.class_id = []
        }
        if(val != old){
          this.delStatus('Type & Stage')
          switch(val){
            case 1:
              this.addStutus('Type & Stage', 'General')
              break
            case 2:
              this.addStutus('Type & Stage', 'Refer Case (All Stages)')
              break
            case 3:
              this.addStutus('Type & Stage', 'Endorsement (All Stages)')
              break
            case 4:
              this.addStutus('Type & Stage', 'HD Transfer (All Stages)')
              break
            case 5:
              this.addStutus('Type & Stage', 'Special/SME (All Stages)')
              break
            case 6:
              this.addStutus('Type & Stage', 'Claims (All Stages)')
              break
            case 7:
              this.addStutus('Type & Stage', 'Renew (All Stages)')
              break
          }
        }
      }
    },
    stts_2:{
      handler(val){
        if(this.type == 2){
          this.delStatus('Type & Stage')
          if(val.length === 0 || val.length == this.globalOptions.ticket_refer_status.length){
            this.addStutus('Type & Stage', 'Refer Case (All Stages)')
          }else{
            this.addStutus('Type & Stage', `Refer Case (${val.length} Stages)`)
          }
        }
      }
    },
    stts_3:{
      handler(val){
        if(this.type == 3){
          this.delStatus('Type & Stage')
          if(val.length === 0 || val.length == this.globalOptions.ticket_endorse_status.length){
            this.addStutus('Type & Stage', 'Endorsement (All Stages)')
          }else{
            this.addStutus('Type & Stage', `Endorsement (${val.length} Stages)`)
          }
        }
      }
    },
    stts_4:{
      handler(val){
        if(this.type == 4){
          this.delStatus('Type & Stage')
          if(val.length === 0 || val.length == this.globalOptions.ticket_transfer_status.length){
            this.addStutus('Type & Stage', 'HD Transfer (All Stages)')
          }else{
            this.addStutus('Type & Stage', `HD Transfer (${val.length} Stages)`)
          }
        }
      }
    },
    stts_5:{
      handler(val){
        if(this.type == 5){
          this.delStatus('Type & Stage')
          if(val.length === 0 || val.length == this.globalOptions.ticket_manual_status.length){
            this.addStutus('Type & Stage', 'Special/SME (All Stages)')
          }else{
            this.addStutus('Type & Stage', `Special/SME (${val.length} Stages)`)
          }
        }
      }
    },
    stts_6:{
      handler(val){
        if(this.type == 6){
          this.delStatus('Type & Stage')
          if(val.length === 0 || val.length == this.globalOptions.ticket_claim_status.length){
            this.addStutus('Type & Stage', 'Claims (All Stages)')
          }else{
            this.addStutus('Type & Stage', `Claims (${val.length} Stages)`)
          }
        }
      }
    },
    stts_9:{
      handler(val){
        if(this.type == 9){
          this.delStatus('Type & Stage')
          if(val.length === 0 || val.length == this.renewOptions.length){
            this.addStutus('Type & Stage', 'Renew (All Stages)')
          }else{
            this.addStutus('Type & Stage', `Renew (${val.length} Stages)`)
          }
        }
      }
    },
    source:{
      immediate: true,
      handler(val){
        this.delStatus('Channel')
        if(val.length){
          let status = []
          val.forEach(item => {
            status.push(this.getOptionName('channelList', item))
          })
          this.addStutus('Channel', status.join(', '))
        }
      }
    },
    refer_date:{
      immediate: true,
      handler(val){
        this.delStatus('Created')
        if(val && val.length){
          let content = val[0] + ' - ' + val[1]
          this.addStutus('Created', content)
        }
      }
    },
    assignee_id:{
      immediate: true,
      handler(val){
        this.delStatus('Assignee')
        if(val){
          let name = this.getOptionName('assigneeList',val)
          this.addStutus('Assignee', name)
        }
      }
    },
    is_snooze:{
      immediate: true,
      handler(val){
        this.delStatus('Snooze')
        if(val.length){
          let Snooze = []
          val.forEach(item => {
            Snooze.push(this.getOptionName('snoozeTypeOptions', item))
          })
          this.addStutus('Snooze', Snooze.join(', '))
        }
      }
    },
    status:{
      immediate: true,
      handler(val){
        this.delStatus('Status')
        if(val.length && JSON.stringify(val) != JSON.stringify(this.defaultFilter.status)){
          let status = []
          val.forEach(item => {
            status.push(this.getOptionName('statusTypeOptions', item))
          })
          this.addStutus('Status', status.join(', '))
        }
      }
    },
    class_id:{
      immediate: true,
      handler(val){
        this.delStatus('Product Type')
        if(val.length){
          let products = []
          val.forEach(item => {
            products.push(this.getOptionName('classTypeOptions', item))
          })
          this.addStutus('Product Type', products.join(', '))
        }
      }
    }
  },
  methods: {
    ...mapActions('common', ['setProductId', 'getCustomerOptionsPhone','setCustomerOptionNUll','getCustomerOptionsEmail','getCustomerOptionsUser']),
    // ...mapActions('common', ['updateGlobalOptions']),
    ...mapActions('filter', ['setFilterData','setOpenFilterCar']),
    handleShowFilter(){
      this.showFilterCard = !this.showFilterCard
      let type = this.ticketsType
      let {ticket ={}} = this.openFilterCar||{}
      ticket[`ticket_${type}`] = {
        showFilterCard:this.showFilterCard
      }

      this.setOpenFilterCar({
        ...this.openFilterCar,
        ticket:{
          ...ticket
        }
      })
    },
    handlerRaido(){
      let name = {
        0:'',
        1:'',
        2:'ticket_refer_status',
        3:'ticket_endorse_status',
        4:'ticket_transfer_status',
        5:'ticket_manual_status',
        6:'ticket_claim_status',
        9:'ticket_renew_status',
      }
      if(this.type==0||this.type==1){
        this.stts = []
        this.stts_4 = []
        this.stts_2 = []
        this.stts_3 = []
        this.stts_5 = []
        this.stts_6 = []
        this.stts_9 = []
      }
      else{
        let arrName =name[this.type]
        let arr = this.globalOptions[arrName]||[]
        const data = arr.reduce((result, item) => {
          result.push(item.id)
          return result
        }, [])
        this.stts= data
        // this[`stts_${this.type}`] = data
      }
      this.filterData(this.type)
    },

    handlerSelectAll(target) {
      let origin = ''
      // if(this.type == 2 || this.type == 3 || this.type == 6) {
      //
      // }
      // if(target=='source') {
      //   origin = 'channelList'
      // }
      switch (target) {
        case 'class_id':
          origin = 'classTypeOptions'
          break
        case 'source':
          origin = 'channelList'
          break
      }
      const data = this[origin].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this[target] = data
      this.filterData(this.type)
    },

    handlerNoneAll(target){
      this[target] = []
      this.filterData(this.type)
    },
    rowClass({ row, rowIndex }) {
      if (this.selectRow.includes(row.id)) {
        return { 'background-color':' rgb(241,248,255)' }
      }
    },
    rowClick(row) {
      if(row.client_updated === 1) {
        this.network().setTicketClientUpdated(row.id)
      }
      let params = {
        status:this.status,
        assignee_id:this.assignee_id,
        is_snooze:this.is_snooze,
        refer_date:this.refer_date,
        stts:this.stts,
        type:this.type,
        pageConfig:this.pageConfig,
        search: this.search,
        class_id: this.class_id,
        source: this.source,
        merchant_platform: this.merchant_platform
      }
      this.setFilterData({ticket:params})

      this.$router.push({
        path: '/tickets/detail',
        query: {
          ticket_id: row.id
        }
      })
    },
    // 新标签打开链接
    rowClickFn(row){
      // if(row.client_updated === 1) {
      //   this.network().setTicketClientUpdated(row.id)
      // }
      return({
        path: '/tickets/detail',
        query: {
          ticket_id: row.id
        }
      })
      // console.log(row)
      // const { id, product_id,pcy_id } = scope
      // return({
      //   path: product_id > 50? '/records/policy/manual/detail': '/records/policy/detail',
      //   query: {
      //     id,
      //     product_id,
      //     pcy_id
      //   }
      // })
    },
    openSupportTicketDialog(type) {
      this.newTicketDialog = false
      this.setCustomerOptionNUll()
      this.$refs[type].changeDialog()
    },
    handlerClearSelection() {
      // this.type = []
      // this.filterData()
      this.selectRow =[]
      this.$refs.table.clearSelection()
    },

    handleSelectionChange(val) {
      this.selectRow =[]
      this.selectionTickets = val
      this.selectionTickets.some(item=>{
        this.selectRow.push(item.id)
      })
    },
    handlerSelected(type) {
      if(this.selectionTickets.length < 1) {
        return
      }
      const ticketId = this.selectionTickets.reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      if(type === 'resolved') {
        this.network().setResolvedTicket(ticketId)
      } else {
        this.network().setTicketUnsnooze(ticketId)
      }
    },
    searchData() {
      if(this.isFirst)
      {
        return this.isFirst =false
      }
      this.pageConfig.currentPage = 1
      this.handler().handlerGetData()
    },
    filterData(type) {
      this.type = type
      if(type!=0&&type!=1)
      {
        this.stts =  this[`stts_${type}`]
        // if(this.stts.length<=0&&!isStts)
        // {
        //   this.type = 0
        // }
        let arr = [2,3,4,5,6,9]
        arr.forEach(item=>{
          if(item!=type){
            this[`stts_${item}`] =[]
          }
        })
      }
      this.pageConfig.currentPage = 1
      this.handler().handlerGetData()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.handler().handlerGetData()
    },
    handlerBluePoint(index) {
      // this.network().setTicketClientUpdated(this.tableData[index].id, index)
    },
    selectAssignee(id) {
      this.network().setTicketCs(id)
    },
    handler() {
      return {
        handlerGetData: () => {
          if(this.ticketsType === 'all') {
            this.network().getAllTicketList()
          }
          else if(this.ticketsType === 'unresolved') {
            this.network().getUnresolvedTicketList()
          }
          else if(this.ticketsType === 'unassigned') {
            this.network().getUnassignedTicketList()
          }
          else {
            this.network().getSnoozedTicketList()
          }
        }
      }
    },
    addStutus(title,content){
      this.statusList.push({
        title,
        content
      })
    },
    delStatus(title){
      // 把符合删除条件的元素都过滤掉
      let arr = []
      arr = this.statusList.filter(item => {
        return item.title !== title
      })
      this.statusList = JSON.parse(JSON.stringify(arr))
    },
    resetFilter(){
      Object.keys(this.defaultFilter).forEach(key => {
        if(this[key]){
          this[key] = this.defaultFilter[key]
        }
      })
      this.filterData()
    },
    network() {
      return {
        getUnresolvedTicketList: async () => {
          const { data } = await getUnresolvedTicketList({
            type: this.type,
            stts: this.stts,
            status: this.status,
            page: this.pageConfig.currentPage,
            refer_date: this.refer_date,
            search: this.search,
            source: this.source,
            merchant_platform:this.merchant_platform
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        },
        getAllTicketList: async () => {
          const { data } = await getAllTicketList({
            type: this.type,
            stts: this.stts,
            assignee_id: this.assignee_id,
            is_snooze: this.is_snooze,
            status: this.status,
            page: this.pageConfig.currentPage,
            search: this.search,
            refer_date: this.refer_date,
            class_id: this.class_id,
            source: this.source,
            merchant_platform:this.merchant_platform
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        },
        getUnassignedTicketList: async () => {
          const { data } = await getUnassignedTicketList({
            type: this.type,
            stts: this.stts,
            status: this.status,
            page: this.pageConfig.currentPage,
            refer_date: this.refer_date,
            search: this.search,
            source: this.source,
            merchant_platform:this.merchant_platform
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        },
        getSnoozedTicketList: async () => {
          const { data } = await getSnoozedTicketList({
            type: this.type,
            stts: this.stts,
            // status: this.status,
            page: this.pageConfig.currentPage,
            refer_date: this.refer_date,
            search: this.search,
            merchant_platform:this.merchant_platform
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        },
        setResolvedTicket: async (ticketId) => {
          const { data } = await setResolvedTicket({
            ticket_id: ticketId,
          })
          this.handler().handlerGetData()
        },
        setTicketUnsnooze: async (ticketId) => {
          const { data } = await setTicketUnsnooze({
            ticket_id: ticketId
          })
          this.handler().handlerGetData()
        },
        setTicketClientUpdated: async (id, index) => {
          const { data } = await setTicketClientUpdated({
            ticket_id: id
          })
          // if(data.code === 1000) {
          //   this.tableData[index].client_updated = 0
          // }
        },
        setTicketCs: async (id) => {
          const { data } = await setTicketCs({
            ticket_id: this.ticketIdList,
            assignee_id: id
          })
          this.assignee = ''
          this.$message({
            type: 'success',
            message: data.message_language
          })
          this.handler().handlerGetData()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  color: #303133;
  h1{
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    letter-spacing: 0.3px;
    color: #24292E;
    margin-bottom: 15px;
  }
  .hide-selection {
    width: 100%;
    /deep/ tr {
      td:first-child, th:first-child {
        display: none;
      }
    }

  }

  .blue-circle {
    position: relative;
    display: inline-block;
    margin-right: 5px;
    width: 8px;
    height: 8px;
    border-radius: 100%;
    cursor: pointer;
    position: absolute;
    left: -5px;
    &.blue{
      background: #409EFF;
    }
    &.yellow-circle{
      background: #DBAB09!important;
    }
    &::after {
      content: '';
      position: absolute;
      top: -5px;
      left: -5px;
      right: -5px;
      bottom: -5px;
    }
  }
  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }
  .text-right {
    display: flex;
    justify-content: flex-end;
    .el-input {
      margin-left: 10px;
      width: 250px;
    }
    .el-button{
      height: 32px;
      margin-left: 0;
      margin-right: 15px;
    }
    .button-blue{
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.15px;
      color: #0366D6;
    }
    .filter-select{
      margin-left: 0;
      margin-right: 15px;
    }
  }
  .filter-top{
    margin-bottom: 14px;
  }
  .filter-flex {
    margin-top: 10px;
    .form-item:first-child {
      margin-right: 15px;
      width: 400px;
    }
    .form-item:last-child {
      width: 400px;
    }
  }
  .filter-select {
    margin-left: 10px;
    width: 175px;
  }

  .transparent {
    margin-top: 15px;
  }
  .dialog-container {
    .dialog-header {
      position: relative;
      padding: 15px 15px 5px 15px;
      border-bottom: 1px solid #dddfe7;
      .abs-top-right {
          top: 15px;
          right: 15px;
      }
    }
    .dialog-body {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 15px 0;
      .mg-l-0{
        margin-left: 0;
      }
      span {
        display: block;
        margin-bottom: 10px;
        cursor: pointer;
      }
    }
  }
  .filter-bar{
    border: 1px solid #D1D5DA;
    height: 46px;
    padding: 11px 16px;
    background: #FFFFFF;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    white-space: nowrap;
    .icon{
      font-weight: 900;
      font-size: 14px;
      color: #586069;
    }
    .main-left{
      display: flex;
      overflow: hidden;
    }
    .left{
      margin-right: 15px;
      .icon-filter{
        margin-right: 11px;
      }
      .text{
        font-weight: 600;
        font-size: 14px;
      }
    }
    .filter-status{
      .status-item{
        height: 24px;
        padding: 4px 8px;
        background: #F1F8FF;
        border-radius: 100px;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: #0366D6;
        .content{
          font-weight: 600;
        }
        & + .status-item{
          margin-left: 18px;
        }
      }
    }
    .right{
      display: flex;
      align-items: center;
      position: relative;
      padding-left: 16px;
      .translucence{
        position: absolute;
        right: 100%;
        width: 15px;
        height: 44px;
        background: linear-gradient(90deg, rgba(219, 237, 255, 0) 0%, #DBEDFF 100%);
      }
      .right-cotent{
        background: #DBEDFF;
      }
      .icon-rotate{
        margin-right: 18px;
        color: #0366D6;
      }
    }
    &.blue-bg{
      background: #DBEDFF;
    }
  }
  .border-bottom-radius{
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .filter-container {
    margin-bottom: 30px;
    background: white;
    border: 1px solid #D1D5DA;
    border-top: none;
    padding: 0px 16px;
    display: flex;
    .filter-box-text{
      display: flex;
      margin-bottom: 12px;
      /*justify-content: space-between;*/
      margin-right: 20px;
      span{
        margin-right: 10px;
        font-family: Inter;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 17px;
      }
      span:first-child{
        color: #24292E;
        font-weight: 600;

      }
      .flex{
        span{
          color: #0366D6;
          cursor: pointer;
        }
      }
    }
    .all {
      display: inline-block;
      padding-left: 15px;
      color: #409eff;
      cursor: pointer;
      font-weight: 600;
    }
    .flex-wrap{
      flex-wrap: wrap !important;
    }
    .filter-left, .filter-middler, .filter-right, .filter-last {
      padding: 16px 0;
    }
    .filter-left {
      padding-right: 10px;
      width: 290px;
      flex: 1;

    }
    .filter-middler {
      padding: 15px 10px;
      border-left: 1px solid #E1E4E8;
      //border-right: 1px solid #E1E4E8;
      flex: 2;
    }
    .filter-right {
      padding: 15px 10px;
      border-left: 1px solid #E1E4E8;
      flex: 1;
    }
    & > span:first-child {
      font-size: 12px;
      font-weight: bold;
    }


    .input-container {
      max-width: 360px;
    }
    .button-right {
      // position: absolute;
      // right: 0;
      margin-left: 20px;
    }

    .filter-box {
      margin-right: 20px;
      .span-status {
        display: flex;
        align-items: center;
        /deep/ .el-checkbox__label {
          margin-left: 10px;
          padding: 0 10px;
          font-size: 12px;
          border: 1px solid #b08800;
          color: #b08800;
          background: white;
          border-radius: 50px;
          line-height: 20px;
          white-space: nowrap;
        }
      }
      .upload-status {
        display: flex;
        align-items: center;
        /deep/ .el-checkbox__label {
          margin-left: 10px;
          padding: 0 10px;
          font-size: 12px;
          border: 1px solid #0366D6;
          color: #0366D6;
          background: white;
          border-radius: 50px;
          line-height: 20px;
          white-space: nowrap;
        }
      }
    }
    .type-button {
      ::v-deep .el-radio {
        //margin-right: 20px!important;
        width: 138px;
        .el-radio__label {
          display: inline-block;
          padding: 0px 10px;
          height: auto;
          //line-height: 30px;
          font-size: 12px;
          border-radius: 50px;
          border: 1px solid #E1E4E8;
          color: #24292E;
          background: white;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 18px;
          margin-left:8px ;
        }
      }
      .border-none{
        ::v-deep .el-radio {
          .el-radio__label {
            border: none;
            font-size: 14px;
            /*border-radius: 50px;*/
            border:none;
            color: #24292E;
            background: white;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 18px;
          }
        }
      }
    }
    .status-button {
      // margin-right: 20px;
      /*margin-top:20px;*/
      ::v-deep .el-checkbox-group {
        .el-checkbox {
          .el-checkbox__label {
            span {
              display: inline-block;
              padding: 0px 10px;
              height: auto;
              //line-height: 30px;
              font-size: 12px;
              border-radius: 50px;
              border: 1px solid #E1E4E8;
              color: #24292E;
              background: white!important;
              font-weight: 500;
              letter-spacing: 0;
              line-height: 18px;
            }
          }
          &:first-child {
            .el-checkbox__label {
              span {
                border: 1px solid #735C0F;
                color: #735C0F;
              }
            }
          }
            &:nth-child(2) {
              .el-checkbox__label {
                span {
                  border: 1px solid #0366D6;
                  color: #0366D6;
                }
              }
            }
          &:nth-child(3) {
              .el-checkbox__label {
                span {
                  border: 1px solid #22863A;
                  color: #22863A;
                }
              }
            }
          &:nth-child(4) {
            .el-checkbox__label {
              span {
                border: 1px solid #F56C6D;
                color: #F56C6D;
              }
            }
          }
        }
      }
    }

    .snooze-filter {
      // margin-right: 20px;
      /*margin-top:20px;*/
      ::v-deep .el-checkbox-group {
        .el-checkbox {
          margin-right: 20px;
          .el-checkbox__label {
            padding: 0;
            span {
              display: flex;
              display: inline-block;
              //padding: 0px 10px;
              height: auto;
              //line-height: 30px;
              font-size: 14px;
              /*border-radius: 50px;*/
              border:none;
              color: #24292E;
              background: white;
              font-weight: 600;
              letter-spacing: 0;
              line-height: 18px;
            }
          }
        }
      }
    }

    .el-checkbox-group {
      //display: flex;
      //flex-wrap: nowrap;
    }
  }
  .flex-checkout{
    display: flex;
    margin-top: 11px;
    .el-checkbox-group {
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      align-items: flex-start;
    }
    .flex{
      align-items: center;
    }
  }
  .circle {
    display: inline-block;
    margin-right: 5px;
    width: 14px;
    height: 14px;
    min-width: 14px;
    min-height: 14px;
    border-radius: 100%;
    &.orange-light {
      background: #E36209;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.green {
      background: #28A745;
    }
    &.red {
      background: #D73A49;
    }
    &.purple {
      background: #6F42C1;
    }
    &.gray {
        background: #6A737D;
    }
  }

  ::v-deep .tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    height: 45px;
    th {
      background-color:#F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      color: #24292E;
      height: 45px;
      .cell{
        height: 30px;
      }
    }
  }
  .span-status {
    /*display: block;*/
    margin-right: 5px;
    padding: 0 8px;
    //height:  20px;
    //line-height: 20px;
    border-radius: 25px;
    white-space: nowrap;

    height: 18px;
    //font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #24292E;
    &.success {
      color:  rgb(67, 181, 92);
      background: rgb(220, 255, 228);
    }
    &.warning {
      background: rgb(255, 245, 177);
      color: rgb(218, 193, 93);
    }
    &.error {
      background: rgb(215, 58, 73);
      color: white;
    }
    &.warning-plain {
      border: 1px solid #B08800;
      color: #B08800;
    }
    &.unread-uplod {
      border: 1px solid #0366D6;
      color: #0366D6;
    }
    &.type-status{
      border: 1px solid #E1E4E8;
      color: #24292E;
    }
  }
  .status-height{
    height: 18px;
    line-height: 18px;
    padding: 0px 10px;
  }
  .status-two{
    border: 1px solid #0366D6;
    color: #0366D6;
    display: inline-block;
    padding: 0px 8px;
    font-size: 12px;
    border-radius: 50px;
    height: 18px;
    line-height: 18px;
    //font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
  }
  .status-one{
    border: 1px solid #735C0F;
    color: #735C0F;
    display: inline-block;
    padding: 0px 8px;
    font-size: 12px;
    border-radius: 50px;
    height: 18px;
    line-height: 18px;
    //font-family: Inter;
    font-style: normal;
    font-weight: 600;
  }
  .status-three
  {
    border: 1px solid #22863A;
    color: #22863A;
    display: inline-block;
    padding: 0px 8px;
    font-size: 12px;
    border-radius: 50px;
    height: 18px;
    line-height: 18px;
    //font-family: Inter;
    font-style: normal;
    font-weight: 600;
  }
  .span-status-stts{
    //font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    /* identical to box height, or 150% */
    display: inline-block;
    color: #FFFFFF;
    padding: 0px 8px;
    height: 18px;

    //background: #E36209;
    border-radius: 100px;
    &.orange-light {
      background: #E36209;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.green {
      background: #28A745;
    }
    &.red {
      background: #D73A49;
    }
    &.purple {
      background: #6F42C1;
    }

  }
  .flex-aglin{
    display: flex;
    flex-direction: column;
    justify-content:space-between ;
    p{
      height: 24px;
    }
  p:first-child{
    color: #24292E;
    font-size: 14px;
    font-weight: 600;
  }
  }
    .liter-text{
      color: #6A737D;
      font-family: Inter;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 18px;
      height: 18px;
    }

  .text-right{
    position: absolute;
    z-index: 100;
    right: 1px;
    margin-top: 6px;
    //margin-right: 15px;
    height: 40px;
    width: 90%;
    background-color:#F6F8FA !important;
  }
}
.el-table{
  border-radius: 4px;
  border:1px solid #D1D5DA;
  ::v-deep .flex-algin{
    //display: flex;
    //flex-direction: column;
    //justify-content:space-between ;
    p,span{
      height: 24px;
    }
    .flex-circle{
      height: 24px;
      align-items: center;
      span{
        color: #24292E;
        font-size: 14px;
        font-weight: 600;
      }
    }
    p:first-child{
      color: #24292E;
      font-size: 14px;
      font-weight: 600;
      span{
        font-weight: 600;
      }
    }
  }
  .liter-time{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    color: #24292E;
  }
  .liter-text{
    color: #6A737D;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 15px;
  }
  .text-span{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #24292E;
  }
  ::v-deep .el-table-column--selection{
    .cell{
      padding-left: 15px!important;
    }
  }
  ::v-deep td{
    padding: 10px 0!important;
    vertical-align: top;
  }
  ::v-deep .el-checkbox:last-of-type{
    margin-top: 4px;
  }
}
.showLick{
  color:  #000;
  text-decoration: none;
  &:hover{
    color:  #0366D6;
  }
}
.half{
  span{
    display: block;
    padding-bottom: 5px;
    font-size: 14px;
    color: #6a737d;
  }
}
</style>
